<template>
  <div id="overview">
    <nav-list class="bg-default padded" id="nav-bar"/>
    <div id="project-details" class="padded">
      {{ loadingError }}
        <header class="header-with-buttons">
            <h2 class="display-6 project-block-header">{{ projectdata.Name }}</h2>
        </header>
        <p class="display-7">{{ projectdata.Description }}</p>
        <p>Members:</p>
        <ul>
          <li v-for="member in projectmembers">
            {{member.username}}
          </li>
        </ul>
    </div>
  </div>
</template>

<script>
  import Loader from '../components/ui/Loader.vue'
  import NavList from '../components/lists/NavList.vue';
  import axios from 'axios'

  export default {
    components: {
      NavList,
      Loader
    },
    data () {
        return {
            projectdata: {},
            projectmembers: {},
            loadingError: '',
            token: JSON.parse(localStorage.getItem('user')).id,
            memberId: JSON.parse(localStorage.getItem('user')).userId
        }
    },
    methods: {
      getProjectData(){
          axios.get(process.env.VUE_APP_ROOT_API+'/members/'+this.memberId+'/Projects/'+this.$route.params.projectid+'?access_token='+this.token)
          .then(response => {
              this.projectdata = response.data
              this.loading = false
          })
          .catch(function (error) {
            if (error.response.status === 401) {
              console.log(error.response.statusText)
              this.loadingError = error.response.statusText
            }
          });
      },
      getProjectMembers(){
          axios.get(process.env.VUE_APP_ROOT_API+'/Projects/'+this.$route.params.projectid+'/members?access_token='+this.token)
          .then(response => {
              this.projectmembers = response.data
              this.loading = false
          })
      }
    },
    mounted() {
      this.getProjectData();
      this.getProjectMembers();
    },
        watch: {
            '$route' (to, from) {
                this.getProjectData()
            }
        }
  }
</script>

<style lang="scss" scoped>
  #overview{
    display: flex;
    height: 100vh;
    width: 100vw;
  }

  #nav-bar{
    flex: 1;
    height: 100vh;
    overflow: auto;
  }
  
  #project-details{
    flex: 4;
  }

  @media #{$phone} {
    #overview{
      width: 100vw;
      height: 100vh;
      overflow: hidden;
    }

    #nav-bar{
      flex: 1;
    }
  
    #project-details{
      flex: 2;
    }
  }
</style>